/**
 * @generated SignedSource<<d6c938356a770ad8c773322ca608ead2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AbtestScenarioPageGroupReferrerReportOrderField = "UNIQUE_USER" | "CONVERSION_USER" | "CONVERSION_USER_RATE" | "%future added value";
export type AgeRange = "LT12" | "GT12LT19" | "GT20LT24" | "GT25LT29" | "GT30LT34" | "GT35LT39" | "GT40LT44" | "GT45LT49" | "GT50LT54" | "GT55LT59" | "%future added value";
export type AnnualIncome = "LT200" | "GT200LT400" | "GT400LT600" | "GT600LT800" | "GT800LT1000" | "GT1000LT1200" | "GT1200LT1500" | "GT1500LT2000" | "GT2000" | "%future added value";
export type Browser = "IE" | "CHROME" | "SAFARI" | "FIREFOX" | "EDGE" | "OTHER" | "%future added value";
export type DeliverKind = "EQUAL" | "WEIGHT" | "%future added value";
export type Device = "MOBILE" | "TABLET" | "PC" | "%future added value";
export type Gender = "MALE" | "FEMALE" | "%future added value";
export type OrderDirection = "ASC" | "DESC" | "%future added value";
export type PageKind = "LANDING" | "FORM" | "CONFIRM" | "THANKS" | "%future added value";
export type Platform = "IOS" | "WINDOWS" | "ANDROID" | "MAC" | "LINUX" | "OTHER" | "%future added value";
export type UserRole = "SUPER" | "ADMIN_ALL" | "ADMIN" | "JUDGE" | "CLIENT" | "SAAS_CLIENT" | "%future added value";
export type ReportAnalyzerInput = {
  startOn: string;
  endOn: string;
  device?: Device | null;
  sourceId?: string | null;
  funnelId?: string | null;
};
export type AbtestScenarioPageGroupReferrerReportOrder = {
  direction: OrderDirection;
  field: AbtestScenarioPageGroupReferrerReportOrderField;
};
export type ABTestDetailPageContainer_Query$variables = {
  slug: string;
  analyzerInput: ReportAnalyzerInput;
  startDate?: string | null;
  endDate?: string | null;
  order?: AbtestScenarioPageGroupReferrerReportOrder | null;
};
export type ABTestDetailPageContainer_QueryVariables = ABTestDetailPageContainer_Query$variables;
export type ABTestDetailPageContainer_Query$data = {
  readonly viewer: {
    readonly role: UserRole;
  };
  readonly abtestScenarioPageGroup: {
    readonly ageRanges: ReadonlyArray<AgeRange>;
    readonly annualIncomes: ReadonlyArray<AnnualIncome>;
    readonly deliverKind: DeliverKind | null;
    readonly devices: ReadonlyArray<Device>;
    readonly browsers: ReadonlyArray<Browser>;
    readonly genders: ReadonlyArray<Gender>;
    readonly id: string;
    readonly isArchive: boolean;
    readonly isContentAnalyticsEnabled: boolean;
    readonly memo: string | null;
    readonly page: {
      readonly id: string;
      readonly name: string;
      readonly slug: string;
      readonly kind: PageKind;
      readonly sortNumber: number;
      readonly url: string;
      readonly funnel: {
        readonly id: string;
        readonly name: string;
        readonly slug: string;
        readonly siteUrl: string;
      };
    };
    readonly platforms: ReadonlyArray<Platform>;
    readonly repeat: boolean;
    readonly slug: string;
    readonly title: string;
    readonly " $fragmentSpreads": FragmentRefs<"ABTestPatternTable_abtestScenarioPageGroup" | "ABTestDistributionSettingSection_abtestGroup" | "ABTestDeliverDayOfWeeks_abtestScenarioPageGroup" | "ABTestPatternReferrerReportTable_abtestScenarioPageGroup">;
  } | null;
};
export type ABTestDetailPageContainer_QueryResponse = ABTestDetailPageContainer_Query$data;
export type ABTestDetailPageContainer_Query = {
  variables: ABTestDetailPageContainer_QueryVariables;
  response: ABTestDetailPageContainer_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "analyzerInput"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "order"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v7 = [
  {
    "kind": "Variable",
    "name": "endDate",
    "variableName": "endDate"
  },
  {
    "kind": "Variable",
    "name": "order",
    "variableName": "order"
  },
  {
    "kind": "Variable",
    "name": "startDate",
    "variableName": "startDate"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ageRanges",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "annualIncomes",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deliverKind",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "devices",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "browsers",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "genders",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArchive",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isContentAnalyticsEnabled",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memo",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "Page",
  "kind": "LinkedField",
  "name": "page",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sortNumber",
      "storageKey": null
    },
    (v21/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Funnel",
      "kind": "LinkedField",
      "name": "funnel",
      "plural": false,
      "selections": [
        (v14/*: any*/),
        (v18/*: any*/),
        (v19/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "siteUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "platforms",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "repeat",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v26 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 120
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": {
      "direction": "ASC",
      "field": "KIND"
    }
  }
],
v27 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "analyzerInput"
  }
],
v28 = [
  (v14/*: any*/),
  (v18/*: any*/)
],
v29 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "referrer",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "matchOp",
    "storageKey": null
  }
],
v30 = [
  (v14/*: any*/),
  (v21/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ABTestDetailPageContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "AbtestScenarioPageGroup",
        "kind": "LinkedField",
        "name": "abtestScenarioPageGroup",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "analyzerInput",
                "variableName": "analyzerInput"
              }
            ],
            "kind": "FragmentSpread",
            "name": "ABTestPatternTable_abtestScenarioPageGroup"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ABTestDistributionSettingSection_abtestGroup"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ABTestDeliverDayOfWeeks_abtestScenarioPageGroup"
          },
          {
            "args": (v7/*: any*/),
            "kind": "FragmentSpread",
            "name": "ABTestPatternReferrerReportTable_abtestScenarioPageGroup"
          },
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v19/*: any*/),
          (v25/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ABTestDetailPageContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v14/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "AbtestScenarioPageGroup",
        "kind": "LinkedField",
        "name": "abtestScenarioPageGroup",
        "plural": false,
        "selections": [
          (v19/*: any*/),
          {
            "alias": null,
            "args": (v26/*: any*/),
            "concreteType": "AbtestScenarioPageConnection",
            "kind": "LinkedField",
            "name": "abtestScenarioPages",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AbtestScenarioPageEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AbtestScenarioPage",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      (v19/*: any*/),
                      (v25/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "weight",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": (v27/*: any*/),
                        "kind": "ScalarField",
                        "name": "uniqueUserCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v27/*: any*/),
                        "kind": "ScalarField",
                        "name": "cvUserCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v27/*: any*/),
                        "kind": "ScalarField",
                        "name": "cvr",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v27/*: any*/),
                        "kind": "ScalarField",
                        "name": "averageStayTime",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v27/*: any*/),
                        "kind": "ScalarField",
                        "name": "scrollRate",
                        "storageKey": null
                      },
                      (v20/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "judgeStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__id",
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": "abtestScenarioPages(first:120,orderBy:{\"direction\":\"ASC\",\"field\":\"KIND\"})"
          },
          {
            "alias": null,
            "args": (v26/*: any*/),
            "filters": [
              "withArchived",
              "orderBy",
              "status"
            ],
            "handle": "connection",
            "key": "ABTestPatternTable_abtestScenarioPageGroup_abtestScenarioPages",
            "kind": "LinkedHandle",
            "name": "abtestScenarioPages"
          },
          (v14/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Source",
            "kind": "LinkedField",
            "name": "sources",
            "plural": true,
            "selections": (v28/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Source",
            "kind": "LinkedField",
            "name": "excludeSources",
            "plural": true,
            "selections": (v28/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AbtestScenarioPageGroupReferrer",
            "kind": "LinkedField",
            "name": "referrers",
            "plural": true,
            "selections": (v29/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AbtestScenarioPageGroupExcludeReferrer",
            "kind": "LinkedField",
            "name": "excludeReferrers",
            "plural": true,
            "selections": (v29/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "visitCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "visitMatchType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AbtestScenarioPageGroupDeliverTargetUrl",
            "kind": "LinkedField",
            "name": "deliverTargetUrls",
            "plural": true,
            "selections": (v30/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AbtestScenarioPageGroupDeliverExcludeUrl",
            "kind": "LinkedField",
            "name": "deliverExcludeUrls",
            "plural": true,
            "selections": (v30/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AbtestScenarioPageGroupTargetCookie",
            "kind": "LinkedField",
            "name": "targetCookies",
            "plural": true,
            "selections": [
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "matchType",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DeliverDayOfWeek",
            "kind": "LinkedField",
            "name": "deliverDayOfWeeks",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "weekOfMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "daysOfWeek",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Schedule",
            "kind": "LinkedField",
            "name": "schedules",
            "plural": true,
            "selections": [
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startTime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endTime",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v7/*: any*/),
            "kind": "ScalarField",
            "name": "reportReferrer",
            "storageKey": null
          },
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "97be47f63823d12c3b14cc910afc72db",
    "id": null,
    "metadata": {},
    "name": "ABTestDetailPageContainer_Query",
    "operationKind": "query",
    "text": "query ABTestDetailPageContainer_Query(\n  $slug: String!\n  $analyzerInput: ReportAnalyzerInput!\n  $startDate: ISO8601Date\n  $endDate: ISO8601Date\n  $order: AbtestScenarioPageGroupReferrerReportOrder\n) {\n  viewer {\n    role\n    id\n  }\n  abtestScenarioPageGroup(slug: $slug) {\n    ...ABTestPatternTable_abtestScenarioPageGroup_4AzHBv\n    ...ABTestDistributionSettingSection_abtestGroup\n    ...ABTestDeliverDayOfWeeks_abtestScenarioPageGroup\n    ...ABTestPatternReferrerReportTable_abtestScenarioPageGroup_1DyTq8\n    ageRanges\n    annualIncomes\n    deliverKind\n    devices\n    browsers\n    genders\n    id\n    isArchive\n    isContentAnalyticsEnabled\n    memo\n    page {\n      id\n      name\n      slug\n      kind\n      sortNumber\n      url\n      funnel {\n        id\n        name\n        slug\n        siteUrl\n      }\n    }\n    platforms\n    repeat\n    slug\n    title\n  }\n}\n\nfragment ABTestDeliverDayOfWeeks_abtestScenarioPageGroup on AbtestScenarioPageGroup {\n  startDate\n  endDate\n  deliverDayOfWeeks {\n    weekOfMonth\n    daysOfWeek\n  }\n  schedules {\n    id\n    startTime\n    endTime\n  }\n}\n\nfragment ABTestDistributionSettingSection_abtestGroup on AbtestScenarioPageGroup {\n  sources {\n    id\n    name\n  }\n  excludeSources {\n    id\n    name\n  }\n  referrers {\n    referrer\n    matchOp\n  }\n  excludeReferrers {\n    referrer\n    matchOp\n  }\n  visitCount\n  visitMatchType\n  deliverTargetUrls {\n    id\n    url\n  }\n  deliverExcludeUrls {\n    id\n    url\n  }\n  targetCookies {\n    id\n    key\n    value\n    matchType\n  }\n}\n\nfragment ABTestPatternReferrerReportTable_abtestScenarioPageGroup_1DyTq8 on AbtestScenarioPageGroup {\n  reportReferrer(startDate: $startDate, endDate: $endDate, order: $order)\n  id\n}\n\nfragment ABTestPatternTableDataRow_abtestPattern_9vDjd on AbtestScenarioPage {\n  id\n  slug\n  title\n  status\n  isArchive\n  uniqueUserCount(input: $analyzerInput)\n  cvUserCount(input: $analyzerInput)\n  cvr(input: $analyzerInput)\n  averageStayTime(input: $analyzerInput)\n  scrollRate(input: $analyzerInput)\n  kind\n  judgeStatus\n  weight\n}\n\nfragment ABTestPatternTable_abtestScenarioPageGroup_4AzHBv on AbtestScenarioPageGroup {\n  slug\n  abtestScenarioPages(first: 120, orderBy: {field: KIND, direction: ASC}) {\n    totalCount\n    edges {\n      node {\n        id\n        slug\n        title\n        weight\n        ...ABTestPatternTableDataRow_abtestPattern_9vDjd\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "c279657b3980d2a841bcdd891d9ea3d9";

export default node;
